// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YegNGQdoxj0F_3lO {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-4);
	padding: var(--lok-spacing-2);
	border: 1px solid var(--lok-color-border-light);
	border-radius: var(--lok-radius-l);
}

.xUxLnVD8hMrr5BD_ {
	color: var(--lok-color-text-disabled);
	font: var(--lok-typography-body-tiny-default);
}

.pL_uaq83AsIM68ZH {
	color: var(--lok-color-text-light-default);
	font: var(--lok-typography-body-caption-default);
}

.LZZT1jnbKcVGnCbV {
	background-color: var(--lok-color-background-surface-default);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/KeysForLanguage/components/Card/Card.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,6BAA6B;CAC7B,+CAA+C;CAC/C,kCAAkC;AACnC;;AAEA;CACC,qCAAqC;CACrC,6CAA6C;AAC9C;;AAEA;CACC,0CAA0C;CAC1C,gDAAgD;AACjD;;AAEA;CACC,6DAA6D;AAC9D","sourcesContent":[".card {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-4);\n\tpadding: var(--lok-spacing-2);\n\tborder: 1px solid var(--lok-color-border-light);\n\tborder-radius: var(--lok-radius-l);\n}\n\n.cardTitle {\n\tcolor: var(--lok-color-text-disabled);\n\tfont: var(--lok-typography-body-tiny-default);\n}\n\n.cardContents {\n\tcolor: var(--lok-color-text-light-default);\n\tfont: var(--lok-typography-body-caption-default);\n}\n\n.highlight {\n\tbackground-color: var(--lok-color-background-surface-default);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `YegNGQdoxj0F_3lO`,
	"cardTitle": `xUxLnVD8hMrr5BD_`,
	"cardContents": `pL_uaq83AsIM68ZH`,
	"highlight": `LZZT1jnbKcVGnCbV`
};
export default ___CSS_LOADER_EXPORT___;
